import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import accountApi from '../../services/accountApi';

function slugifyName(name) {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function CreateTenantPage() {
  const navigate = useNavigate();
  const { refreshSession, setActiveTenant } = useAuth();
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [slugTouched, setSlugTouched] = useState(false);
  const [partnerType, setPartnerType] = useState('studio');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slugTouched) {
      setSlug(slugifyName(name));
    }
  }, [name, slugTouched]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const membership = await accountApi.createPartner({
        name,
        slug: slug || undefined,
        partner_type: partnerType,
      });
      await refreshSession();
      const partnerId = membership && (membership.partner_id || membership.tenant_id);
      if (partnerId) {
        setActiveTenant(partnerId);
      }
      navigate('/console', { replace: true });
    } catch (err) {
      setError(err.message || 'Failed to create partner');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <h1 className="product-page-title">Create Partner</h1>
      <p className="product-page-subtitle">
        Start a studio, agency, or sandbox partner. You will be the Partner Owner.
      </p>

      {error && <Alert variant="danger">{error}</Alert>}

      <div className="product-card">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Partner name</Form.Label>
            <Form.Control
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="Hexbit Studio"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Slug</Form.Label>
            <Form.Control
              value={slug}
              onChange={(e) => {
                setSlugTouched(true);
                setSlug(e.target.value);
              }}
              placeholder="hexbit-studio"
            />
            <Form.Text className="text-muted">
              Preview: /partners/{slug || '…'} — auto-generated until you edit it.
            </Form.Text>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Partner type</Form.Label>
            <Form.Select
              value={partnerType}
              onChange={(e) => setPartnerType(e.target.value)}
            >
              <option value="studio">Studio</option>
              <option value="agency">Agency</option>
              <option value="sandbox">Sandbox</option>
            </Form.Select>
          </Form.Group>
          <Button type="submit" disabled={submitting}>
            {submitting ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Creating…
              </>
            ) : (
              'Create Partner'
            )}
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default CreateTenantPage;
